export default async function ajaxRequest(url, data) {
    try {
        return fetch(url, {
            method: 'POST',
            mode: 'same-origin',
            cache: 'reload',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Parent-Accept': window.Application.x_parent_accept || "",
            },
            redirect: 'follow',
            referrerPolicy: 'same-origin',
            body: JSON.stringify(data)
        }).then(async (response) => {
            const responseText = await response.text();
            
            try {
                return JSON.parse(responseText);
            } catch (err) {
                return {
                    error: err
                };
            }
        });
    } catch (err) {
        return {
            error: err
        };
    }
}